import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { listCategories } from '../Api'

export default generateApiAction({
  baseType: Types.CATEGORIES.LIST,
  api: listCategories,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/categories/ListAction.js